import type { I18nDict } from '../types.ts'

export const sv: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Inställningar',
  section_language: 'Språk',
  section_identity: 'Lokal identitet',
  section_updates: 'Appuppdatering',
  section_notifications: 'Aviseringar',
  section_theme: 'Visuellt tema',
  section_backup: 'Säkerhetskopia av chatt',
  section_privacy_network: 'Nätverksintegritet',
  section_media: 'Multimedia',
  section_security: 'Säkerhet och lösenord',
  section_exit: 'Stäng och radera data',
  toggle_external_links: 'Ta emot och visa externa länkar',
  hint_external_links: 'Om AV: inga länkförhandsvisningar i chatten och externa URL:er kan inte öppnas (skydd mot IP-spårning).',
  toggle_auto_media: 'Automatisk nedladdning av media och dokument',
  hint_auto_media: 'Om AV: foton, videor och filer laddas inte ned i bakgrunden — tryck manuellt i chatten.',
  toggle_require_unlock: 'Lösenord vid appstart',
  hint_require_unlock: 'När PÅ krävs huvudlösenordet varje gång du öppnar ZION.',
  toggle_wipe_exit: 'Radera data vid avslut',
  hint_wipe_exit: 'När PÅ rensas tillfällig RAM-cache och sessionsdata när appen stängs.',
  btn_exit: 'Avsluta',
  btn_delete_all: 'RADERA ALL DATA',
  btn_lock: 'Lås appen',
  btn_back: 'Tillbaka',
  warn_disable_password_title: '⚠️ VARNING',
  warn_disable_password_body: 'Att inaktivera öppningslösenordet innebär att vem som helst med tillgång till din enhet kan läsa dina krypterade meddelanden. Är du säker på att du vill fortsätta?',
  warn_delete_all_1: 'Vill du verkligen förstöra hela databasen? Denna åtgärd kan inte ångras.',
  warn_delete_all_2: 'Slutlig bekräftelse: alla chattar, privata nycklar och inställningar raderas permanent.',
  link_blocked: 'Extern länk blockerad (integritetsinställningar).',
  lang_welcome_title: 'Välkommen till ZION',
  lang_welcome_sub: 'Välj ditt språk',
  lang_continue: 'Fortsätt',
  settings_language_label: 'Appspråk',
  auth_unlock_title: 'Lås upp',
  auth_or_password: '— eller lås upp med lösenord —',
  auth_password_master: 'Huvudlösenord',
  auth_unlock_btn: 'Lås upp',
  auth_verifying: 'Verifierar…',
  auth_wrong_password: 'Fel lösenord',
  auth_unlocked: 'Upplåst ✓',
  auth_access_title: 'Gå med i ZION',
  auth_beta_spots: 'Gratis beta · platser kvar:',
  auth_beta_full: 'Beta full ({max} användare). Försök igen senare.',
  auth_beta_free: 'Gratis beta · ingen licens krävs',
  auth_or_create: '— eller skapa en ny identitet —',
  auth_password_min: 'Lösenord (min. 8 tecken)',
  auth_password_confirm: 'Bekräfta lösenord',
  auth_privacy_check: 'Jag har läst',
  auth_privacy_link: 'Integritetspolicyn',
  auth_terms_check: 'Jag accepterar',
  auth_terms_link: 'Användarvillkoren',
  auth_password_local_hint: 'Lösenordet lämnar aldrig denna enhet. Inget serverkonto.',
  auth_create_identity: 'Skapa identitet',
  auth_accept_legal_err: 'Acceptera integritet och villkor för att fortsätta',
  auth_generating_keys: 'Genererar nycklar och session…',
  auth_generating_identity: 'Genererar anonym identitet…',
  auth_generating_detail: 'ECDH-nycklar · smeknamn · socket-session · ZN- kod',
  auth_you_are: 'Du är',
  auth_daily_suffix_hint: 'Det dagliga suffixet ändras varje UTC-dag. För att para ihop, använd ZN- koden på Hem.',
  auth_enter: 'Gå in i ZION',
  auth_starting: 'Startar…',
  auth_restore_title: 'Återställ säkerhetskopia',
  auth_restore_hint: 'Har du redan en krypterad säkerhetskopia? Återställ identitet, kontakter och chattar (t.ex. efter att ha rensat cache).',
  auth_restore_file: 'Säkerhetskopieringsfil (.enc / .enc.json)',
  auth_restore_pass: 'Lösenfras för säkerhetskopia',
  auth_restore_pass_ph: 'Lösenfras som användes vid export',
  auth_restore_btn: 'Återställ säkerhetskopia',
  auth_restore_pick_file: 'Välj en säkerhetskopieringsfil (.enc eller .enc.json).',
  auth_restore_need_pass: 'Ange lösenfrasen.',
  auth_restoring: 'Återställer…',
  auth_file_prefix: 'Fil:',
  common_accept: 'Acceptera',
  common_reject: 'Avvisa',
  common_cancel: 'Avbryt',
  common_accepting: 'Accepterar…',
  common_error: 'Fel',
  common_loading: 'Laddar…',
  common_send: 'Skicka',
  common_copied: 'Kopierat ✓',
  common_copy_failed: 'Kopiering misslyckades',
  common_ok: 'OK',
  common_today: 'Idag',
  common_yesterday: 'Igår',
  common_sending: 'Skickar…',
  home_zn_midnight_hint: 'Ändras vid UTC midnatt (om {h}h {m}m)',
  home_temp_empty: 'Inga tidsbegränsade chattar. Tryck ⏱ på en kontakt för att starta en.',
  home_unread_aria: '{count} meddelanden',
  home_temp_waiting: 'Väntar på acceptans…',
  home_temp_expires: 'Tidsbegränsad chatt · går ut om {remaining}',
  home_temp_cancel: 'Avbryt',
  home_temp_fallback_label: 'tidsbegränsad chatt',
  home_temp_invite_title: '⏱ Inbjudan till tidsbegränsad chatt',
  home_temp_invite_body: '{nick} vill ha en tillfällig chatt ({duration}).',
  home_temp_invite_hint: 'Acceptera för att börja utbyta meddelanden som försvinner vid utgång.',
  home_temp_accept: 'Acceptera',
  home_temp_reject: 'Avvisa',
  home_temp_accepting: 'Accepterar…',
  home_contacts_empty: 'Inga kontakter. Dela din ZN- kod eller QR för att para ihop.',
  home_temp_chat_aria: 'Tidsbegränsad chatt',
  home_btn_pair_title: 'Para ihop',
  home_btn_settings_title: 'Inställningar',
  home_zn_title: 'Dagens ZN- kod',
  home_btn_copy_zn: 'Kopiera ZN-',
  home_btn_open_pair: 'Parning QR',
  home_section_temp: 'Tidsbegränsade chattar',
  home_section_chat: 'Chattar',
  home_loading: 'Laddar…',
  home_pair_zn_title: 'Para ihop med ZN- kod',
  home_btn_zn_pair: 'Skicka förfrågan',
  home_copied: 'Kopierat ✓',
  home_copy_failed: 'Kopiering misslyckades',
  home_pair_request_title: 'Kontaktförfrågan',
  home_pair_request_body: '{name} vill chatta.',
  home_pair_reject: 'Avvisa',
  home_pair_accept: 'Acceptera',
  home_pair_accepting: 'Accepterar…',
  home_pair_accept_failed: 'Acceptans misslyckades',
  home_zn_digits_err: 'Ange de 5 siffrorna efter ZN-.',
  home_sending: 'Skickar…',
  chat_rename: 'Byt namn',
  chat_rename_matrix: '[BYT NAMN]',
  chat_rename_title: 'Byt namn på kontakt',
  chat_menu_title: 'Chattalternativ',
  chat_loading: 'Laddar meddelanden…',
  chat_reply_to: 'Svara till',
  chat_cancel_title: 'Avbryt',
  chat_voice_lock_hint: 'Svep uppåt för att låsa inspelning',
  chat_voice_locked: 'Inspelning låst — tryck Klar',
  chat_voice_stop: 'KLAR',
  chat_voice_stop_title: 'Klar',
  chat_voice_preview_label: 'Röstförhandsvisning — lyssna innan du skickar',
  chat_voice_send: 'SKICKA',
  chat_voice_send_title: 'Skicka',
  chat_timer_label: 'Timer',
  chat_timer_title: 'Meddelandetimer',
  chat_timer_off: 'AV',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Foto',
  chat_photo_title: 'Foto',
  chat_voice_hold: 'Håll för att spela in',
  chat_voice_hold_title: 'Håll för att spela in',
  chat_doc: 'Dok',
  chat_doc_title: 'Dokument',
  chat_attach_title: 'Bilagor',
  chat_input_placeholder: 'E2E-krypterat meddelande…',
  chat_send: 'Skicka',
  chat_rename_modal_title: 'Byt namn på kontakt',
  chat_rename_nickname: 'Smeknamn: @{nick}',
  chat_rename_placeholder: 'Eget namn',
  chat_rename_cancel: 'Avbryt',
  chat_rename_save: 'Spara',
  chat_action_reply: '↩ Svara',
  chat_action_copy: '⎘ Kopiera',
  chat_action_delete_me: '🗑 Radera för mig',
  chat_action_delete_all: '🗑 Radera för alla',
  chat_action_cancel: 'Avbryt',
  chat_menu_clear_me: '🗑 Rensa chatt (endast för mig)',
  chat_menu_clear_all: '🗑 Radera chatt för alla',
  chat_menu_cancel: 'Avbryt',
  chat_doc_send_title: 'Skicka dokument',
  chat_doc_default_name: 'dokument',
  chat_doc_send_hint: 'Filen komprimeras, E2E-krypteras och skickas. Max 5 MB.',
  chat_doc_cancel: 'Avbryt',
  chat_doc_send_encrypted: 'Skicka krypterat',
  chat_doc_too_large: '⚠️ FILEN ÄR FÖR STOR: Den maximala säkerhetsgränsen för dokument är 5 MB.',
  chat_doc_unsupported: 'Dokumenttypen stöds inte.',
  chat_copy_failed: 'Kopiering misslyckades',
  chat_confirm_delete_me: 'Radera detta meddelande endast för dig?',
  chat_confirm_delete_all: 'Radera detta meddelande för alla?',
  chat_confirm_clear_all: 'Radera hela chatten för alla? Denna åtgärd kan inte ångras.',
  chat_confirm_clear_me: 'Rensa chatten endast för dig?',
  chat_jump_new: '↓ Nya meddelanden',
  chat_empty: 'Inga meddelanden. Skriv något för att börja.',
  chat_voice_err_short: 'Röstmeddelande för kort (minst 1 sekund).',
  chat_voice_err_long: 'Röstmeddelande för långt (max 2 minuter).',
  chat_voice_err_large: 'Röstmeddelande för stort (max 3 MB).',
  chat_voice_err_start: 'Röstinspelning kunde inte startas.',
  chat_destroyed: '✉ Meddelande läst och förstört',
  chat_destroyed_title: 'Meddelande läst och förstört',
  chat_hold_options: 'Håll för alternativ',
  chat_reply_fallback: 'Meddelande',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'ZN- koden ändras vid UTC midnatt (om {h}h {m}m).',
  pair_copied: 'Kopierat ✓',
  pair_copy_failed: 'Kopiering misslyckades',
  pair_title: 'Parning',
  pair_zn_title: 'Din ZN- kod idag',
  pair_btn_copy_zn: 'Kopiera ZN- kod',
  pair_tab_mine: 'Min QR',
  pair_tab_scan: 'Skanna / ZN-',
  pair_qr_aria: 'Parning QR',
  pair_expires_in: 'Går ut om',
  pair_btn_copy_payload: 'Kopiera payload',
  pair_btn_regen_qr: 'Generera ny QR',
  pair_qr_hint: 'Visa denna QR för den andra enheten. Giltig i 10 minuter — kompatibel med Android-appen.',
  pair_expired: 'utgången',
  pair_contact_zn_title: 'Kontaktens ZN- kod',
  pair_zn_prefix_hint: 'Prefixet <strong>ZN-</strong> är redan inställt — ange endast de 5 bokstäverna/siffrorna.',
  pair_btn_zn_request: 'Skicka ZN- förfrågan',
  pair_paste_title: 'Eller klistra in en ZION1:: QR',
  pair_paste_hint: 'Klistra in en <code>ZION1::</code> payload eller ladda upp ett foto av QR-koden.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Från foto / kamera',
  pair_btn_connect_qr: 'Anslut med QR',
  pair_zn_digits_err: 'Ange de 5 siffrorna efter ZN-.',
  pair_sending: 'Skickar förfrågan…',
  pair_reading_qr: 'Läser QR…',
  pair_qr_not_found: 'QR-kod hittades inte i bilden.',
  pair_zn_read_ok: 'ZN- kod läst — bekräfta med Skicka förfrågan.',
  pair_qr_read_ok: 'QR läst — bekräfta med Anslut med QR.',
  pair_qr_read_err: 'Fel vid läsning av QR.',
  settings_identity_hint: 'Lösenord och nycklar stannar i denna webbläsare. Inget serverkonto.',
  settings_btn_add_home: 'Guide för Lägg till på Hemskärmen',
  settings_devices_title: 'Länkade enheter',
  settings_devices_hint: 'Multi-enhet Zero-Knowledge: nycklar skickas E2E-krypterat. Servern är endast en relä.',
  settings_btn_link_device: 'Länka ny enhet',
  settings_btn_sync_pc: 'Synka PC-historik',
  settings_no_devices: 'Inga länkade enheter.',
  settings_device_self: 'denna enhet',
  settings_version_prefix: 'Version:',
  settings_ios_push_hint: '<strong>iPhone:</strong> aviseringar = PWA från Hem + Banner/Ljud PÅ. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Tvinga appuppdatering',
  settings_updating: 'Uppdaterar…',
  settings_push_mode_prefix: 'Läge:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> aviseringar fungerar endast när ZION öppnas från ikonen på hemskärmen (Dela → Lägg till på hemskärmen). I vanlig Safari är de <em>inte</em> tillgängliga — även på iOS 17. Efter installation på hemskärmen, kom tillbaka hit och tryck Aktivera aviseringar.',
  settings_btn_enable_push: 'Aktivera pushaviseringar',
  settings_btn_desktop_notify: 'Skrivbordsaviseringar (PC)',
  settings_btn_disable_push: 'Inaktivera aviseringar',
  settings_desktop_requesting: 'Begär skrivbordsbehörighet…',
  settings_desktop_ok: 'Skrivbordsaviseringar aktiva (ljud + popup vid nytt meddelande).',
  settings_desktop_denied: 'Behörighet nekad eller stöds inte.',
  settings_push_no_session: 'Sessionen är inte redo.',
  settings_push_requesting: 'Begär behörighet…',
  settings_push_active: 'Aviseringar aktiva.',
  settings_push_disabled: 'Aviseringar inaktiverade.',
  settings_theme_hint: 'Samma teman som ZION Android-appen.',
  settings_theme_recommended: 'Rekommenderat',
  settings_backup_hint: 'JSON-fil krypterad med lösenfras (kompatibel med Android v2-format). Spara på din PC: kontakter, chattar och webbidentitet.',
  settings_backup_pass_label: 'Lösenfras för säkerhetskopia',
  settings_backup_pass_ph: 'Dedikerad lösenfras (min. 8 tecken)',
  settings_btn_export_backup: 'Exportera säkerhetskopia',
  settings_backup_file_label: 'Återställ från fil',
  settings_backup_import_pass_label: 'Lösenfras för säkerhetskopia',
  settings_backup_import_pass_ph: 'Lösenfras som användes vid export',
  settings_btn_import_backup: 'Återställ säkerhetskopia',
  settings_backup_file_prefix: 'Fil: {name}',
  settings_backup_pass_min: 'Lösenfrasen måste vara minst 8 tecken.',
  settings_backup_creating: 'Skapar säkerhetskopia…',
  settings_backup_pick_file: 'Välj en säkerhetskopieringsfil (.enc eller .enc.json).',
  settings_backup_need_pass: 'Ange lösenfrasen för säkerhetskopian.',
  settings_backup_restoring: 'Återställer…',
  settings_backup_overwrite_confirm: 'Skriva över lokal data?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minuter',
  temp_duration_10m: '10 minuter',
  temp_duration_15m: '15 minuter',
  temp_duration_30m: '30 minuter',
  temp_duration_1h: '1 timme',
  temp_duration_6h: '6 timmar',
  temp_duration_24h: '24 timmar',
  temp_duration_7d: '7 dagar',
  temp_remaining_expired: 'Utgången',
  temp_remaining_days: '{days}d {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Tidsbegränsad chatt · tillfälliga meddelanden',
  temp_empty: 'Inga tillfälliga meddelanden.',
  temp_empty_hint: 'Skriv ett tillfälligt meddelande. Det försvinner när timern går ut.',
  temp_input_placeholder: 'Tillfälligt meddelande…',
  temp_send: 'Skicka',
  temp_waiting_accept: 'Väntar på att {name} accepterar den tidsbegränsade chatten…',
  temp_waiting_placeholder: 'Väntar på acceptans…',
  temp_expires_in: 'Går ut om {remaining}',
  temp_duration_title: 'Tidsbegränsad chatt',
  temp_duration_with: 'Med {name}',
  temp_duration_hint: 'Välj varaktighet — chatten försvinner från båda enheterna.',
  temp_sending_invite: 'Skickar inbjudan…',
  voice_lock_hint: 'Svep uppåt för att låsa inspelning',
  voice_locked: 'Inspelning låst — tryck Klar',
  add_home_title: 'Lägg till på hemskärmen (iPhone / iPad)',
  add_home_guide_title: 'Safari-guide',
  add_home_step1: 'Öppna <strong>Safari</strong> på denna sida (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Tryck på <strong>Dela</strong> (kvadrat med pil uppåt)',
  add_home_step3: 'Välj <strong>Lägg till på hemskärmen</strong>',
  add_home_step4: 'Öppna ZION från <strong>ikonen</strong> — inte från en Safari-flik',
  add_home_hint: 'På iOS/iPadOS 16.4+ stöder hemskärmsappen Web Push-aviseringar och chatt-tangentbordet. Efter installation, gå till <strong>Inställningar → Aktivera aviseringar</strong>.',
  add_home_btn_continue: 'Förstått — fortsätt',
  add_home_btn_skip: 'Hoppa över för nu',
  search_title: 'Sök med ZN- kod',
  search_label: 'Daglig ZN- kod',
  search_placeholder: 'ZN-123456',
  search_btn: 'Sök',
  search_hint: 'Ange kontaktens ZN- kod. Ingen smeknamnssökning — identiteten är endast lokal.',
  search_format_err: 'Format: ZN-123456',
  search_resolving: 'Löser kod…',
  search_invalid_code: 'Ogiltig kod — be om en uppdaterad ZN- (öppna ZION igen på den andra personens enhet)',
  search_session_found: 'session hittad',
  search_tap_to_send: 'Tryck för att skicka förfrågan',
  search_socket_not_ready: 'Socket-sessionen är inte redo',
  search_request_sent: 'Förfrågan skickad ✓',
  search_request_failed: 'Skickning misslyckades',
  license_title: 'Webb- / iPhone-licensaktivering',
  license_heading: 'Licens',
  license_heading_updated: 'Uppdaterade villkor',
  license_hint: 'Ange koden <strong>ZION-XXXX-XXXX-XXXX</strong> som köpts på zionyx.ch. Den kopplas till denna webbläsare (lokal nyckel).',
  license_code_label: 'Licenskod',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Aktivera licens',
  license_beta_hint: 'Webb-beta: använd en dedikerad iPhone-licens om tillgänglig.',
  license_accept_legal_err: 'Acceptera integritet och villkor för att fortsätta',
  license_need_code: 'Ange licenskoden',
  license_verifying: 'Verifierar licens…',
  license_invalid_or_used: 'Ogiltig licens eller redan använd på en annan enhet',
  license_active: 'Licens aktiv ✓',
  license_err_not_found: 'Ogiltig licenskod',
  license_err_conflict: 'Licens redan kopplad till en annan enhet',
  license_err_rate_limit: 'För många försök — vänta en minut',
  license_err_generic: 'Licensfel',
  link_device_title: 'Länka ny enhet',
  link_device_hint: 'På din <strong>PC</strong>, öppna Inställningar → Länka ny enhet: du ser den <strong>gröna QR</strong>. Skanna den nedan (kamera eller foto).',
  link_device_status_ready: '[REDO]',
  link_device_upload_label: 'Ladda upp QR-foto',
  link_device_btn_camera: 'Öppna kamera / galleri',
  link_device_placeholder: 'QR-länk eller payload…',
  link_device_btn_send_vault: 'Skicka krypterat valv',
  link_device_err_invalid_qr: 'Ogiltig eller utgången QR.',
  link_device_status_invalid: '[OGILTIG QR]',
  link_device_status_sync_complete: '[SYNK KLAR]',
  link_device_status_transfer_failed: '[ÖVERFÖRING MISSLYCKADES]',
  link_device_status_qr_detected: '[QR UPPTÄCKT — ÖVERFÖR...]',
  link_device_status_tap_camera: '[TRYCK PÅ DEN GRÖNA KNAPPEN — IPHONE-KAMERA]',
  link_device_status_use_camera_below: '[ANVÄND KAMERA / GALLERI NEDAN]',
  link_device_status_point_camera: '[RIKTA KAMERAN MOT PC-QR...]',
  link_device_status_decoding: '[AVKODAR QR...]',
  link_device_status_qr_not_found: '[QR HITTADES INTE]',
  link_device_status_decode_failed: '[AVKODNING MISSLYCKADES]',
  link_device_status_opened_from_qr: '[ÖPPNAD FRÅN QR — STARTAR...]',
  link_recv_title: 'Länka från telefon',
  link_recv_hint_compact:
    'Skanna denna <strong>gröna QR</strong> med telefonen (Inställningar → Länka ny enhet). Valvet är end-to-end-krypterat.',
  link_recv_hint_auth:
    'Har du redan ZION på telefonen? Skanna denna QR med <strong>Kameran</strong> — datorn länkar och loggar in automatiskt.',
  link_recv_qr_alt: 'QR för enhetslänkning',
  link_recv_copy_link: 'Kopiera länk',
  link_recv_awaiting: '[VÄNTAR PÅ TELEFONSKANNING — TUNNEL ÖPPEN...]',
  link_recv_failed: '[PARNING MISSLYCKADES]',
  link_recv_tunnel_lost:
    'Tunneln avbröts — valvet kan fortfarande vara på väg. Försök skanna QR igen.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Nytt krypterat meddelande',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Tillfälligt meddelande',
  force_update_title: '🚨 OBLIGATORISK KRITISK UPPDATERING — För att fortsätta använda Zionyx säkert måste du ladda ner den senaste versionen.',
  force_update_desc: 'Den installerade klienten är inte kompatibel med den minimiversion som är aktiv på servern.',
  force_update_versions: 'Installerad: v{current} · Krävs: v{required}',
  force_update_btn: 'UPPDATERA NU',
}
